import { Grid, Radio } from "@material-ui/core"
import { useState, useEffect } from "react";
import { AppDispatch } from "../../redux/store";
import {useSelector, useDispatch, } from "react-redux";
import { Bar } from "react-chartjs-2";
import { SelectBox, Text } from "sunrise-ui";
import FilterComponent from "../../components/helperComponents/FilterComponent";
import { DATA_NOT_FOUND } from "../../constants/globalConstants";
import { CHART_COLORS, customTooltip } from "../../constants/reactChartConstants";
import SelectOptionMsg from "../../utilities/SelectOptionMsg";
import { getAllProjectData } from "../../redux/reducers/projectReducers";
import { getOverallExpensesByProjectTypeForGraph, getExpensesForProjectInventoryGraph,
getExpensesForProjectSubContractorGraph, getExpensesForProjectMachineRentalGraph,
getExpensesForProjectMachineryRepairGraph, getExpensesForProjectMiscellaneousGraph, getOverallExpenses, getOverallExpensesInventory, getOverallExpensesSubContractor, getOverallExpensesMachineRental, getOverallExpensesMachineryRepair, getOverallExpensesMiscellaneous } from "../../redux/reducers/billReducer";

const ExpenseReportBar = () => {
    const dispatch = useDispatch<AppDispatch>();
    const [value, setValue] = useState({ from: "", to: "" });
    const [isOverallBar, setIsOverallBar] = useState(true);
  const [projectName2, setProjectName2] = useState("");
  const [projectId2, setProjectId2] = useState("");
const allProjectData = useSelector(
        (state: any) => state.PROJECT.allProjectData
      );
 const profileData = useSelector((state: any) => state.PROFILE.profileDetails);

    const overallExpenses = useSelector((state: any) => state.BILLS.overallExpenses);
    const overallInventory = useSelector((state: any) => state.BILLS.overallExpensesInventory);
    const overallSubContractor = useSelector((state: any) => state.BILLS.overallExpensesSubContractor);
    const overallMachineRental = useSelector((state: any) => state.BILLS.overallExpensesMachineRental);
    const overallMachineryRepair = useSelector((state: any) => state.BILLS.overallExpensesMachineryRepair);
    const overallMiscellaneous = useSelector((state: any) => state.BILLS.overallExpensesMiscellaneous);
 //-------------------for overall expenses of selected project----------------------------
 const overallProjectExpensesGraph = useSelector((state: any) => state.BILLS.overallExpensesByProjectTypeForGraph);
  //----------------------for project and bill wise (Graph)---------------------------------
  const graphInventory = useSelector((state: any) => state.BILLS.expensesForProjectInventoryGraph);
  const graphSubContractor = useSelector((state: any) => state.BILLS.expensesForProjectSubContractorGraph);
  const graphMachineRental = useSelector((state: any) => state.BILLS.expensesForProjectMachineRentalGraph);
  const graphMachineryRepair = useSelector((state: any) => state.BILLS.expensesForProjectMachineryRepairGraph);
  const graphMiscellaneous = useSelector((state: any) => state.BILLS.expensesForProjectMiscellaneousGraph);
  const handleFilterDate = () => { 
 if(projectId2 && value.to && value.from){
    dispatch(
      getOverallExpensesByProjectTypeForGraph({
            endPoint: `manage-bill/expense-report-by-project?projectId=${projectId2}&to=${value.to}&from=${value.from}`
        })
    );
    dispatch(
      getExpensesForProjectInventoryGraph({
            endPoint: `manage-bill/expense-report-by-type-and-project?billType=inventory&projectId=${projectId2}&to=${value.to}&from=${value.from}`
        })
    );
    dispatch(
      getExpensesForProjectSubContractorGraph({
            endPoint: `manage-bill/expense-report-by-type-and-project?billType=sub-contractor&projectId=${projectId2}&to=${value.to}&from=${value.from}`
        })
    );
    dispatch(
      getExpensesForProjectMachineRentalGraph({
            endPoint: `manage-bill/expense-report-by-type-and-project?billType=machine-rental&projectId=${projectId2}&to=${value.to}&from=${value.from}`
        })
    );
    dispatch(
      getExpensesForProjectMachineryRepairGraph({
            endPoint: `manage-bill/expense-report-by-type-and-project?billType=machinery-repair&projectId=${projectId2}&to=${value.to}&from=${value.from}`
        })
    );
    dispatch(
      getExpensesForProjectMiscellaneousGraph({
            endPoint: `manage-bill/expense-report-by-type-and-project?billType=miscellaneous&projectId=${projectId2}&to=${value.to}&from=${value.from}`
        })
    );
 }
 else if(!projectId2 && value.to && value.from){
  dispatch(
    getOverallExpenses({
        endPoint: `manage-bill/expense-report?to=${value.to}&from=${value.from}`,
    })
);
dispatch(
    getOverallExpensesInventory({
        endPoint: `manage-bill/expense-report-by-type?billType=inventory&to=${value.to}&from=${value.from}`,
    })
);
dispatch(
    getOverallExpensesSubContractor({
        endPoint: `manage-bill/expense-report-by-type?billType=sub-contractor&to=${value.to}&from=${value.from}`,
    })
);
dispatch(
    getOverallExpensesMachineRental({
        endPoint: `manage-bill/expense-report-by-type?billType=machine-rental&to=${value.to}&from=${value.from}`,
    })
);
dispatch(
    getOverallExpensesMachineryRepair({
        endPoint: `manage-bill/expense-report-by-type?billType=machinery-repair&to=${value.to}&from=${value.from}`,
    })
);
dispatch(
    getOverallExpensesMiscellaneous({
        endPoint: `manage-bill/expense-report-by-type?billType=miscellaneous&to=${value.to}&from=${value.from}`,
    })
);
 }
}

const resetToAll = () => { 
    setValue({ from: "", to: "" });
    dispatch(
      getOverallExpenses({
          endPoint: `manage-bill/expense-report`,
      })
  );
  dispatch(
      getOverallExpensesInventory({
          endPoint: `manage-bill/expense-report-by-type?billType=inventory`,
      })
  );
  dispatch(
      getOverallExpensesSubContractor({
          endPoint: `manage-bill/expense-report-by-type?billType=sub-contractor`,
      })
  );
  dispatch(
      getOverallExpensesMachineRental({
          endPoint: `manage-bill/expense-report-by-type?billType=machine-rental`,
      })
  );
  dispatch(
      getOverallExpensesMachineryRepair({
          endPoint: `manage-bill/expense-report-by-type?billType=machinery-repair`,
      })
  );
  dispatch(
      getOverallExpensesMiscellaneous({
          endPoint: `manage-bill/expense-report-by-type?billType=miscellaneous`,
      })
  );
}
    const changeReset = () => {    };
//-----Rs. to Lacs conversion----
const numToLacs = (value: any) => {
    let val = Math.abs(value)
    if (val >= 100000) {
      val = +(val / 100000).toFixed(2);
    }
    else { val = +(val / 100000).toFixed(2);
    }
    return val;
  }

  useEffect(() => {
    if(profileData){
      dispatch(
        getAllProjectData({
          endPoint: `project/get-all-projects`,
        })
      );
    }
  }, [dispatch, profileData])

  const projectsData: [] =
  allProjectData &&
  allProjectData?.map((item: any) => {
    return item?.projectName;
  });  
//--------------Fetching projectwise details for table------------
useEffect(() => {
    if(projectId2 !== ''){
      dispatch(
          getOverallExpensesByProjectTypeForGraph({
            endPoint: `manage-bill/expense-report-by-project?projectId=${projectId2}`
          })
        );
        dispatch(
            getExpensesForProjectInventoryGraph({
              endPoint: `manage-bill/expense-report-by-type-and-project?billType=inventory&&projectId=${projectId2}`
            })
          );
      dispatch(
            getExpensesForProjectSubContractorGraph({
              endPoint: `manage-bill/expense-report-by-type-and-project?billType=sub-contractor&&projectId=${projectId2}`
            })
          );
     dispatch(
            getExpensesForProjectMachineRentalGraph({
              endPoint: `manage-bill/expense-report-by-type-and-project?billType=machine-rental&&projectId=${projectId2}`
            })
          );
     dispatch(
            getExpensesForProjectMachineryRepairGraph({
              endPoint: `manage-bill/expense-report-by-type-and-project?billType=machinery-repair&&projectId=${projectId2}`
            })
          ); 
     dispatch(
            getExpensesForProjectMiscellaneousGraph({
              endPoint: `manage-bill/expense-report-by-type-and-project?billType=miscellaneous&&projectId=${projectId2}`
            })
          );
    } 
  }, [dispatch, projectId2]);
  //---------------------------ovearll-----------------------
    const barChartData2 = {
        labels: ["F", "E", "D", "C", "B", "A"],
        datasets: [
            {
                label: "Expense",
                data: [numToLacs(overallMiscellaneous?.approve), numToLacs(overallMachineryRepair?.approve), numToLacs(overallMachineRental?.approve),
                    numToLacs(overallSubContractor?.approve),numToLacs(overallInventory?.approve), numToLacs(overallExpenses?.approve)],
                backgroundColor: [CHART_COLORS.BLUE, CHART_COLORS.BLUE, CHART_COLORS.BLUE, CHART_COLORS.BLUE],
                hoverBackgroundColor: [CHART_COLORS.SELECTED_BLUE, CHART_COLORS.SELECTED_BLUE, CHART_COLORS.SELECTED_BLUE, CHART_COLORS.SELECTED_BLUE],
                barThickness: 20
            }
        ],
    };
    //------------------------projectwise--------------------------
    const barChartData3 = {
        labels: ["F", "E", "D", "C", "B", "A"],
        datasets: [
            {
                label: "Expense",
                data: [numToLacs(graphMiscellaneous?.approve), numToLacs(graphMachineryRepair?.approve), numToLacs(graphMachineRental?.approve),
                    numToLacs(graphSubContractor?.approve),numToLacs(graphInventory?.approve), numToLacs(overallProjectExpensesGraph?.approve)],
                backgroundColor: [CHART_COLORS.BLUE, CHART_COLORS.BLUE, CHART_COLORS.BLUE, CHART_COLORS.BLUE],
                hoverBackgroundColor: [CHART_COLORS.SELECTED_BLUE, CHART_COLORS.SELECTED_BLUE, CHART_COLORS.SELECTED_BLUE, CHART_COLORS.SELECTED_BLUE],
                barThickness: 20
            }
        ],
    };
    const overallExpenseBarOptions: any = {
        plugins: {
            tooltip: customTooltip,
            legend: {
                display: false
            }
        },
        indexAxis: 'y',
        scales: {
            y: { title: { display: true, text: 'Expense Parameter', font: { weight: 'bold' } }, },
            x: { title: { display: true, text: 'Amount (Lakhs)', font: { weight: 'bold' } } },
        }
    }
    
    return (
       
            <Grid container>
                <Grid container xs={12} className="d-flex bg--white box--shadow p1 mt1 mr-1">
                    <Grid item xs={12}>
                        <Text
                            type="normal"
                            fonts="normal"
                            fontSize={18}
                            className="mb0 mt0"
                        >
                            <span className="fw500">Expense Report</span>
                        </Text>
                    </Grid>

                    <Grid className="d-flex mt1">
                        <Grid className="radio_box">
                            <Radio
                                checked={isOverallBar}
                                onChange={(e) => {
                                setIsOverallBar(true);
                                setProjectId2('');
                                }}
                                value="mandatory"
                                name="isMandatory"
                                inputProps={{ "aria-label": "Mandatory" }}
                                color="primary"
                            />
                            <label>Overall</label>
                            <Radio
                                checked={!isOverallBar}
                                onChange={(e) => {
                                   setIsOverallBar(false);
                                   setProjectId2('');
                                   setProjectName2('');
                                   }}
                                value="optional"
                                name="isMandatory"
                                inputProps={{ "aria-label": "Optional" }}
                                color="primary"
                            />
                            <label>Project-Wise</label>
                        </Grid>

                        <Grid item className={"ml-1 mt0"}
                            direction="row"
                            alignItems="center">
                            <div className="filter_box_ml">
                                <FilterComponent
                                    handleFilterDate={handleFilterDate}
                                    setValue={setValue}
                                    value={value}
                                    resetAll={resetToAll}
                                />
                            </div>
                        </Grid>
                        {/* <Grid item className="ml-1 mt0">
                            <Button
                                type="button"
                                size="medium"
                                isRounded={true}
                                category="primary"
                                onClick={() => {
                                }}
                                className="submit_button mb1 mr-1 pl pr f14"
                            >
                                <SVG type={"searchIcon"} />
                                Search
                            </Button>
                        </Grid> */}
                    </Grid>
                    <Grid container xs={12} spacing={2}>
                        {!isOverallBar && <Grid item xs={3}>
                            <Text type="normal" fonts="normal" fontSize={18} className="mb0 mt0">
                                <span className="fw500">Select Project</span>
                            </Text>
                            <SelectBox
                                data={projectsData ? projectsData : DATA_NOT_FOUND}
                                placeHolder="Select Project"
                                borderColor={"primary"}
                                defaultValue={projectName2}
                                changeReset={changeReset}
                               onChange={(e: any) => {
                               setProjectName2(e.target.value);
                               const index = projectsData
                               ?.map((item: any) => item)
                                .indexOf(e.target.value);
                               setProjectId2(
                                allProjectData && allProjectData[index]?._id
                      );
                    }}
                            />
                        </Grid>}
                    </Grid>
                   
                    {!isOverallBar && projectName2 === "" ? (
                            <>
                                <Grid xs={12}>
                                    <SelectOptionMsg text={`Select project to view Project information`} /> </Grid></>) : (               
                        <>
                    <Grid item xs={12}>
                        <Text
                            type="normal"
                            fonts="normal"
                            fontSize={18}
                            className="mb0 mt0"
                        >
                            <span className="fw500">{projectId2 ? 'Selected Project Expense Report' : 'Overall Expense Report' }</span>
                        </Text>
                    </Grid>
                    <Grid container>
              <Grid item xs={7}>
              <Bar data={(projectId2) ? barChartData3 : barChartData2} options={overallExpenseBarOptions} />
               </Grid>
               <Grid item xs={4} className={"p1 ml-1"}>
                  <Text type="normal" fonts="normal" fontSize={16} className="mb1_5 mt0">
               <Grid className="d-flex v-center w100">
                   <Grid className="w100 parameter">
                     <span className="fw500 bolder">Parameter Name</span>
                     <span className="fw500 float-right bolder"> Amount(Lakhs)  </span>
                   </Grid>
                   </Grid>
                 </Text>
                <Text type="normal" fonts="normal" fontSize={16} className="mb1_5 mt0">
                   <Grid className="d-flex v-center w100">
                      <Grid className="w100 parameter_values">
                        <span className="fw400">A. Total Expense Approved (TEA)</span>
                         <span className="fw400 float-right">{(!isOverallBar && projectId2 !== '') ? numToLacs(overallProjectExpensesGraph?.approve) 
                        : numToLacs(overallExpenses?.approve)  } 
                          </span>
                      </Grid>
                     </Grid>
                </Text>
                 <Text type="normal" fonts="normal" fontSize={16} className="mb1_5 mt0" >
                 <Grid className="d-flex v-center w100">
                   <Grid className="w100 parameter_values">
                     <span className="fw400">B. Inventory Expense (IE)</span>
                    <span className="fw400 float-right">{(!isOverallBar && projectId2 !== '') ? numToLacs(graphInventory?.approve)
                    : numToLacs(overallInventory?.approve) } </span>
                   </Grid>
                 </Grid>
                </Text>
                 <Text type="normal" fonts="normal" fontSize={16} className="mb1_5 mt0">
               <Grid className="d-flex v-center w100">
                  <Grid className="w100 parameter_values">
                     <span className="fw400">C. Labour Contractor Expense (LCE)</span>
                     <span className="fw400 float-right"> {(!isOverallBar && projectId2 !== '') ? numToLacs(graphSubContractor?.approve)
                     : numToLacs(overallSubContractor?.approve)} </span>
               </Grid>
                </Grid>
                 </Text>
                 <Text type="normal" fonts="normal" fontSize={16} className="mb1_5 mt0">
               <Grid className="d-flex v-center w100">
                 <Grid className="w100 parameter_values">
                    <span className="fw400">D. Machinery Rental Expense (MRE)</span>
                    <span className="fw400 float-right">{(!isOverallBar && projectId2 !== '') ? numToLacs(graphMachineRental?.approve)
                     : numToLacs(overallMachineRental?.approve)} </span>
                 </Grid>
                 </Grid>
               </Text>
               <Text type="normal" fonts="normal" fontSize={16} className="mb1_5 mt0">
                  <Grid className="d-flex v-center w100">
                     <Grid className="w100 parameter_values">
                      <span className="fw400">E. Machinery Repair Expense (MRE)</span>
                      <span className="fw400 float-right">{(!isOverallBar && projectId2 !== '') ? numToLacs(graphMachineryRepair?.approve)
                      : numToLacs(overallMachineryRepair?.approve)} </span>
                    </Grid>
                   </Grid>
                 </Text>
                 <Text type="normal" fonts="normal" fontSize={16} className="mb1_5 mt0">
                  <Grid className="d-flex v-center w100">
                    <Grid className="w100 parameter_values">
                       <span className="fw400">F. Miscellaneous Expense (ME)</span>
                         <span className="fw400 float-right">{(!isOverallBar && projectId2 !== '') ? numToLacs(graphMiscellaneous?.approve)
                         : numToLacs(overallMiscellaneous?.approve)} </span>
                     </Grid>
                  </Grid>
                </Text>
            </Grid>
         </Grid>
         </>
         )}
                </Grid>
            </Grid>

    )
}

export default ExpenseReportBar;